import {ReactNode} from 'react';

import {Handler, HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {OrNull} from '../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {Expression} from '../../../editors/expressions/expressionModel';
import {LikeId, SelectedDropdownItem} from '../dropdowns/dropdownWithExpressions';

/*
 * Types.
 */

export interface GenericSingleParameterProps<T extends LikeId> {
  expressions?: ReadonlyArray<Expression>;
  isDisabled?: boolean;
  selectedItem: OrNull<SelectedDropdownItem<T>>;
  onChange: HandlerOf<OrNull<SelectedDropdownItem<T>>>;
  onSelectCreateExpression?: Handler;
}

export interface GenericMultipleParameterProps<
  T extends LikeId,
  TAdditionalGroupItems extends unknown[] = [],
> {
  expressions?: ReadonlyArray<Expression>;
  isDisabled?: boolean;
  selectedItems: OrNull<ReadonlyArray<SelectedDropdownItem<T, TAdditionalGroupItems>>>;
  canSelectAnyItem?: true;
  selectedItemsSeparator?: ReactNode;
  maxItemsToRender?: number;
  onChange: HandlerOf<OrNull<ReadonlyArray<SelectedDropdownItem<T, TAdditionalGroupItems>>>>;
  onToggle?: HandlerOf<boolean>;
  onSelectCreateExpression?: Handler;
}

export const defaultDropdownWidth = 260;
